import { AddCircleOutline } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import { StyledContainer } from './EquipmentMaintenanceTemplatesContainer'
import MaintenanceTemplateTable from './MaintenanceTemplateTable'
import { MaintenanceTemplateType } from 'src/enums'
import { useGetLocalityMaintenanceTemplates } from 'src/api/maintenanceTemplate'
import { IMaintenanceTemplate } from 'src/generated-types/maintenanceTemplate'
import { useDialogCtx } from 'src/hooks/context-hooks'
import CreateMaintenanceTemplateForm from './CreateMaintenanceTemplateForm'

interface LocalityMaintenanceTemplatesContainerProps {
  customerId: EntityId
}

const LocalityMaintenanceTemplatesContainer: React.FC<LocalityMaintenanceTemplatesContainerProps> = ({
  customerId,
}) => {
  const { t: translate } = useTranslation(['maintenance'])
  const { data: loclaityMaintenanceTemplates } = useGetLocalityMaintenanceTemplates(customerId)

  const { showDialog } = useDialogCtx()

  const onAdd = () => {
    showDialog(
      CreateMaintenanceTemplateForm,
      {
        componentProps: {
          customerId: customerId,
          type: MaintenanceTemplateType.Locality,
        },
        opts: {
          maxWidth: 'lg',
          fullWidth: true,
        },
        isAutoCloseDisabled: true,
      },
      undefined,
      true,
    )
  }

  return (
    <CommonPageLayout
      height={'100%'}
      childrenProps={{ flex: 1 }}
      titleSection={{ subtitle: translate('locality-templates', { ns: 'maintenance' }) }}
      topAction={[
        {
          buttonText: translate('addTemplate', { ns: 'maintenance' }),
          buttonIcon: <AddCircleOutline />,
          variant: 'outlined',
          shadowWeight: null,
          border: 0,
          onClick: onAdd,
        },
      ]}
    >
      <StyledContainer>
        <MaintenanceTemplateTable
          templates={loclaityMaintenanceTemplates as IMaintenanceTemplate[]}
          templatesType={MaintenanceTemplateType.Locality}
          pop={() => { }}
          customerId={customerId}
        />
      </StyledContainer>
    </CommonPageLayout>
  )
}

export default LocalityMaintenanceTemplatesContainer
